const getModuleState = (state) => state.nextreleases;

export const getAllNextReleases = (state) => getModuleState(state).allNextReleases;
export const getNextReleaseById = (state) => getModuleState(state).nextReleaseById;
export const getNextReleaseBySlug = (state) => getModuleState(state).nextReleaseBySlug;